import './houses.css'
import {useState, useEffect} from 'react'
import House from '../house/House'
import Outlined from '../div/Outlined'
import { axiosInstance } from '../../config';

function Houses() {
    const [houses, setHouses] = useState([]);
    useEffect(() => {
    const getHouse = async() => {
    try {
        const res = await axiosInstance.get('/api/houses');
    setHouses(res.data)
    } catch (err) {
      console.log(err)  
    }
    }
    getHouse();
    },[])
    return (
        <div className='houses'>
        {axiosInstance}
            <span className='houseTitle'>Our Homes</span>
            <Outlined/>
            <div className='wrapper'>
            {houses.map((house) => (
                <House key ={house.id} house={house}/>
            ))}
            </div>
        </div>
    )
}

export default Houses
